import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { activeRetracement } from 'src/app/Models/ActiveRetracements';
import { DrawingService } from 'src/app/Services/DrawingService';

@Component({
  selector: 'app-retracement-menu',
  templateUrl: './retracement-menu.component.html',
  styleUrls: ['./retracement-menu.component.scss']
})
export class RetracementMenuComponent implements OnInit {


  @ViewChild('rMenu') private rMenu: ElementRef;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  activeRetracement: activeRetracement = null;

  constructor(public drawingService:DrawingService) {
    this.drawingService.retracementMenuActioner.subscribe((v)=>{

      //console.log(v);

      this.rMenu.nativeElement.style.left = `${v.param.point.x}px`;
      this.rMenu.nativeElement.style.top = `${v.param.point.y-10}px`;

      this.activeRetracement = v.retracement;

      this.trigger.openMenu();
    })
  }

  expandeRetracement()
  {
    this.activeRetracement.expanded = true;
    this.drawingService.forceViewUpdate();
    this.drawingService.activeRetracements.storeActiveRetracement()
  }

  collapseRetracement()
  {
    this.activeRetracement.expanded = false;
    this.drawingService.forceViewUpdate();
    this.drawingService.activeRetracements.storeActiveRetracement()
  }

  closeRetracement()
  {
    this.activeRetracement.expanded = false;
    this.drawingService.activeRetracements.removeRetracement(this.activeRetracement.retracement)
  }

  ngOnInit()
  {
  }

}
